const classAnnouncementDetails = {
  path: 'classAnnouncementDetails/:classAnnouncementId',
  component: resolve => require(['../../../../components/pages/student_user/classAnnouncementDetails'], resolve),
  props: true
}
export default classAnnouncementDetails
